// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getCreateAcountState(state: ApplicationState) {
    return state.store.pages.createAccount;
}
